module.exports = __webpack_public_path__ + "static/media/azure.b5ec34bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/azure.jpg
// module id = 853
// module chunks = 18